import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Expositions from '../views/Expositions.vue'
import Contact from '../views/Contact.vue'
import Presse from '../views/Presse.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/expositions',
        name: 'Expositions',
        component: Expositions
    },
    {
        path: '/contact',
        name: 'Contact',
        component: Contact
    },
    {
        path: '/presse',
        name: 'Presse',
        component: Presse
    },
    {
        path: '/mentions',
        name: 'Mentions',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/Mentions.vue')
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior() {
        document.getElementById('app').scrollIntoView();
    }
})

export default router
